const RANK = [
  { n: 1, title: "顶流男团成员深夜被拍，恋情传闻登顶热一", tag: "圈内", heat: "312.4w", up: true },
  { n: 2, title: "新锐消费品牌创始人退出董事会，内部信流出", tag: "商界", heat: "276.1w", up: false },
  { n: 3, title: "带货一哥翻车旧料被挖，删评控楼引热议", tag: "网红·直播", heat: "241.8w", up: true },
  { n: 4, title: "国民级综艺恶意剪辑片段流出，嘉宾喊话制片", tag: "综艺", heat: "203.4w", up: true },
  { n: 5, title: "顶流工作室发声明否认婚变，评论区翻车", tag: "圈内", heat: "156.3w", up: false },
  { n: 6, title: "某剧男二被扒同款行程，CP 营业变拆伙", tag: "圈内", heat: "120.6w", up: false },
  { n: 7, title: "颁奖礼同框无交流，昔日好友疑似疏远", tag: "圈内", heat: "98.7w", up: true },
  { n: 8, title: "高管被指利益输送，深夜发文回应全否认", tag: "商界", heat: "88.8w", up: false },
];

export default function HotRank() {
  return (
    <section id="hot" className="py-10 md:py-14 bg-background-100/60">
      <div className="mx-auto max-w-[1240px] px-4 md:px-6">
        <div className="flex items-center justify-between mb-6">
          <div>
            <p className="flex items-center gap-2 text-[13px] font-semibold text-accent-700 tracking-wide">
              <span className="w-1.5 h-3 rounded-sm bg-accent-500" /> HOT TOP
            </p>
            <h2 className="mt-2 font-heading text-[28px] md:text-[36px] font-black text-foreground-950">本周热度总榜 TOP8</h2>
          </div>
          <span className="hidden md:inline-flex items-center gap-2 rounded-full bg-background-50 border border-background-200 px-4 py-1.5 text-[13px] text-foreground-600 whitespace-nowrap">
            <i className="ri-fire-fill w-4 h-4 text-accent-500 flex items-center justify-center" /> 每小时更新
          </span>
        </div>

        <div className="bg-background-50 rounded-lg border border-background-200 divide-y divide-background-100">
          {RANK.map((r) => (
            <a
              key={r.n}
              href="#recap"
              className="flex items-center gap-4 px-4 md:px-6 py-3.5 hover:bg-background-100 transition-colors group"
            >
              <span
                className={`w-8 shrink-0 text-center font-heading text-[20px] font-black ${
                  r.n <= 3 ? "text-primary-500" : "text-foreground-300"
                }`}
              >
                {r.n}
              </span>
              <span className="w-20 shrink-0 hidden sm:inline-flex">
                <span className="rounded-full bg-secondary-100 text-secondary-800 px-2.5 py-0.5 text-[12px] font-semibold">{r.tag}</span>
              </span>
              <span className="flex-1 min-w-0 text-[14.5px] md:text-[15px] font-medium text-foreground-800 truncate group-hover:text-primary-700 transition-colors">
                {r.title}
              </span>
              <span className="flex items-center gap-2 shrink-0">
                <i className={`${r.up ? "ri-arrow-up-line" : "ri-arrow-down-line"} w-4 h-4 flex items-center justify-center ${r.up ? "text-accent-500" : "text-foreground-300"}`} />
                <span className="text-[13px] font-semibold text-foreground-600">{r.heat}</span>
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}